
<div class="backgroundDialog" style="width: 100%; padding: 0px;margin: auto; border: 5px solid rgb(207, 121, 1);">



    <div style="text-align: center; width: 12%;display: inline-block;  " >
      <mat-card style="border-radius: 0px 30px 30px 0px ; color: white;
                        background-color: rgb(46, 163, 80); font-size: 20px;">
          Anexos
      </mat-card>
    </div>


    <div style="text-align: right; width: 86%; display: inline-block; " >
      <button  (click)="onNoClick()">
        <img src="../../assets/img/icones/fecharJanela.png" width="100%">
    </button>
    </div>
  
  
    <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center;">
        <div *ngIf="data.idMonitoria != undefined" style="margin-top: 7px; ">Id monitoria: {{data.idMonitoria}}</div>
        <div *ngIf="data.dsPlanoAcao != undefined" style="margin-top: 7px; ">Plano ação: {{data.dsPlanoAcao}}</div>
    </div>
  
    <div style="width: 100%;">
      <table style="width: 99.8%; margin: auto;">
          <tr>
              <td style="width:100%">
                  <div>
                      <mat-card class="mat-elevation-z5" style="background-color: rgb(248, 248, 248);color: rgb(138, 138, 140); height: 360px; overflow: hidden;">
                          
                       
                                
                          <table style="text-align: left; width: 100%; height: 98%;">
                              
                              <tr>
                                <td style="width: 100%; height: 100%;" >
                                  <mat-card class="mat-elevation-z5" style=" height: 100%;">
                                        
                                    <input type="file" class="file-input" id="anexo" [accept]="requiredFileType" (change)="onFileSelected($event, fileUpload)" #fileUpload style="display: none;">
                                    <button *ngIf="!data.isFinalizado" mat-mini-fab style="background-color: rgb(207, 121, 1); width: 40px; height: 40px; " class="upload-btn" (click)="fileUpload.click()">
                                        <mat-icon style="width: 25px;">add</mat-icon>
                                    </button>
            
                                    <br/><br/>
                                    <table style="width: 100%;">
                                        <tr >
                                            <td style="width: 75%;">
                                                <b>Arquivo(s) anexo(s) </b>    
                                            </td>
                                            <td style="width: 25%;">
                                                <b>Inserido em:</b>    
                                            </td>
                                        </tr>  
                                    </table>

                                    <hr style=" margin-top: 0px;"/>
                                    <div  style="text-align: left; width: 100%; height: 205px; overflow-y: auto; margin-top: -10px; font-size: 12px; " >
                                       
                                        <table style="width: 100%;">

                                            <tr *ngFor="let list of beanMonitoryFiles" >

                                                <td style="width: 75%;">

                                                    <mat-icon (click)="downloadAnexo(list.moanIdCdMonitoriaAnexo)" style="color: rgb(46, 163, 80); font-size: 16px; font-weight: bold; vertical-align: middle; cursor: pointer; font-weight: bold;" >
                                                        <u>arrow_downward</u>
                                                    </mat-icon>
                                                    <label (click)="downloadAnexo(list.moanIdCdMonitoriaAnexo)" style="cursor: pointer;">{{list.moanDsNomeArquivo}}</label>
                                                       
                                                    
                                                </td>

                                                <td style="width: 25%; ">
                                                    {{list.moanDhRegistro  | date: 'dd/MM/yyyy HH:mm'}}
                                                    <mat-icon *ngIf="!data.isFinalizado" (click)="deletarAnexo(list.moanIdCdMonitoriaAnexo)" style="color: red; font-size: 20px; vertical-align: middle; cursor: pointer; font-weight: bold;" >
                                                        delete_forever
                                                    </mat-icon>
                                                    
                                                </td>
                                            
                                            </tr>
                                            
                                        </table>


                                        <table style="width: 100%;">

                                            <tr *ngFor="let list of beanActionPlanFiles" >

                                                <td style="width: 75%;">

                                                    <mat-icon (click)="downloadAnexoPlanoAcao(list.plaaIdCdPlanoacaoanexo)" style="color: rgb(46, 163, 80); font-size: 16px; font-weight: bold; vertical-align: middle; cursor: pointer; font-weight: bold;" >
                                                        <u>arrow_downward</u>
                                                    </mat-icon>
                                                    <label (click)="downloadAnexoPlanoAcao(list.plaaIdCdPlanoacaoanexo)" style="cursor: pointer;">{{list.plaaDsNomearquivo}}</label>
                                                       
                                                    
                                                </td>

                                                <td style="width: 25%; ">
                                                    {{list.plaaDhRegistro  | date: 'dd/MM/yyyy HH:mm'}}
                                                    <mat-icon *ngIf="!data.isFinalizado" (click)="deletarAnexoPlanoAcao(list.plaaIdCdPlanoacaoanexo)" style="color: red; font-size: 20px; vertical-align: middle; cursor: pointer; font-weight: bold;" >
                                                        delete_forever
                                                    </mat-icon>
                                                    
                                                </td>
                                            
                                            </tr>
                                            
                                        </table>
                                        
                                        
                                      </div>
                                  </mat-card>
                                </td>                              
                            </tr>
  
                        </table>
                        
                      </mat-card>
                  </div>
              </td>
          </tr>
      </table>
      <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; text-align: center;">
        <div  style="margin-top: 7px; margin-left: 15px; color: white;"> {{this.qtdAnexos | json}} anexo(s)  </div>
      </div>
      
      
    </div>
  
  </div>